import version from '../../app-version.json';

export const environment = {
  appVersion: version.version,
  production: true,
  includeFakePortalCookies: false,
};
